module.exports = __webpack_public_path__ + "media/images/badge-guest-9e5fca6b67499e5b2ea4ea223a3f040b.png";